import React, { useState } from "react";
import { connect } from "react-redux";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../../components/Common/TittleLine";
import CheckRender from "../../../../components/Common/CheckRender";
import ConfiguracionStandVirtualBusquedaForm from "../components/ConfiguracionStandVirtualBusquedaForm";
import ConfiguracionStandVirtualBusquedaDetalle from "../components/ConfiguracionStandVirtualBusquedaDetalle";
import ConfiguracionStandVirtualActions from "../../../../stores/cobertura/Actions";
import PrestadorStandVirtualActions from "../../../../stores/prestador/Actions";
import CustomAlert from "../../../../components/Common/CustomAlert";
import { isNumber } from "../../../../utils/NumberUtil";
import useEmpresa from "../../../../hooks/useEmpresa";
import { useUpdateEffect } from "../../../../hooks/LifeCycle";
import { isObjectEmpty } from "../../../../utils/ObjectUtil";
import { mostrarErrorGenerico } from "../../../../utils/AlertUtils";
import ModalLoader from "../../../../components/Common/ModalLoader";

const ConfiguracionStandVirtualScreen = (props) => {
  const empresa = useEmpresa();
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [procedimientos, setProcedimientos] = useState([]);
  const [procedimientoSeleccionado, setProcedimientoSeleccionado] =
    useState(null);
  const [coberturas, setCoberturas] = useState([]);
  const [coberturasOriginales, setCoberturasOriginales] = useState([]);
  const [cambiosPendientes, setCambiosPendientes] = useState(new Map());
  const [prestador, setPrestador] = useState({});
  const [formData, setFormData] = useState({
    tipoPss: "MEDICO",
    codigoPss: null
  });
  const itemsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [tieneModificacionesPendientes, setTieneModificacionesPendientes] =
    useState(false);
  const [filtroCobertura, setFiltroCobertura] = useState("");

  const buscarProcedimientos = () => {
    const { codigoPss } = formData;

    if (!isNumber(codigoPss) || codigoPss === 0) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor ingresar el código PSS.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });

      setShowAlert(true);
      return;
    }

    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.obtenerDatosPss({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      datosPSS: formData
    });

    setTieneModificacionesPendientes(false);
  };

  const showModalLoader = () => {
    const {
      datosPssLoading,
      coberturasPssLoading,
      guardarcoberturasPssLoading,
      actualizarPrestadorStandVirtualLoading
    } = props;
    return (
      datosPssLoading ||
      coberturasPssLoading ||
      guardarcoberturasPssLoading ||
      actualizarPrestadorStandVirtualLoading
    );
  };

  const guardarCoberturas = () => {
    if (procedimientoSeleccionado === null) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message:
          "Favor seleccionar un tipo de procedimiento y las coberturas a asociar o desasociar.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });

      setShowAlert(true);
      return;
    }

    setAlertConfig({
      type: "confirm",
      title: "Confirmación",
      message:
        "¿Está seguro de que desea guardar las coberturas seleccionadas?",
      onConfirm: () => {
        setShowAlert(false);
        process();
      },
      onCancel: () => {
        setShowAlert(false);
      }
    });

    setShowAlert(true);
  };

  const process = () => {
    const { numeroSesionReutilizable } = props?.authUserData;

    const cambiosActualizados = new Map(cambiosPendientes);

    coberturas.forEach((coberturaActual) => {
      const coberturaOriginal = coberturasOriginales.find(
        (orig) => orig.cobertura === coberturaActual.cobertura
      );

      if (!coberturaOriginal) return;

      const estadoOriginal = coberturaOriginal.configurado === 1;
      const estadoActual = coberturaActual.configurado === 1;
      const key = `${coberturaActual.cobertura}`;

      if (estadoOriginal !== estadoActual) {
        cambiosActualizados.set(key, {
          codigoCobertura: coberturaActual.cobertura,
          codigoTipoCobertura:
            coberturaActual.codigoTipoProcedimiento ||
            procedimientoSeleccionado.codigoTipoCobertura,
          esParaEliminar: !estadoActual,
          estadoOriginal,
          estadoActual
        });
      } else {
        cambiosActualizados.delete(key);
      }
    });

    setCambiosPendientes(cambiosActualizados);

    const coberturasParaGuardar = Array.from(cambiosActualizados.values()).map(
      (cambio) => ({
        codigoCobertura: cambio.codigoCobertura,
        codigoTipoCobertura: cambio.codigoTipoCobertura,
        esParaEliminar: cambio.esParaEliminar
      })
    );

    if (coberturasParaGuardar.length === 0) {
      setAlertConfig({
        type: "info",
        title: "Sin Cambios",
        message: "No se detectaron cambios en las coberturas seleccionadas.",
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
      return;
    }

    setProcessing(true);

    props.guardarCoberturasPss({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      tipoPss: formData.tipoPss,
      codigoPss: formData.codigoPss,
      tipoProcedimiento: procedimientoSeleccionado.codigoTipoCobertura,
      coberturas: coberturasParaGuardar
    });

    setTieneModificacionesPendientes(false);
  };

  const onStateChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value
        };
      });
    };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      buscarProcedimientos();
    }
  };

  const onChangeProcedimientoSeleccionado = (value) => {
    setProcedimientoSeleccionado(value);
    setCurrentPage(1);
    setCoberturasOriginales([]);
    setCoberturas([]);
    setCambiosPendientes(new Map());

    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    setFiltroCobertura("");
    props.obtenerCoberturasPss({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      datosPSS: {
        ...formData,
        tipoProcedimiento: value.codigoTipoCobertura,
        numeroPagina: 1,
        tamanoPagina: itemsPerPage
      }
    });
  };

  const handlePageChange = (page, byPassAlert = false) => {
    if (!procedimientoSeleccionado) return;

    if (tieneModificacionesPendientes && !byPassAlert) {
      setAlertConfig({
        type: "confirm",
        title: "¡Hola!",
        message:
          "Tienes modificaciones pendientes. Si continua se perderán los cambios. ¿Desea continuar?",
        onConfirm: () => {
          setTieneModificacionesPendientes(false);
          handlePageChange(page, true);
          setShowAlert(false);
        },
        onCancel: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
      return;
    }

    setCurrentPage(page);

    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.obtenerCoberturasPss({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      datosPSS: {
        ...formData,
        tipoProcedimiento: procedimientoSeleccionado.codigoTipoCobertura,
        numeroPagina: page,
        tamanoPagina: itemsPerPage,
        cobertura: filtroCobertura
      }
    });
  };

  const onChangeSelecionarTodosCoberturas = (value) => {
    setCoberturas((prevState) => {
      return prevState.map((item) => {
        return { ...item, configurado: value ? 1 : 0 };
      });
    });
    setTieneModificacionesPendientes(true);
  };

  const onChangeCoberturaEstatus = (value) => {
    setCoberturas((prevState) => {
      return prevState.map((item) => {
        if (item.cobertura === value.cobertura) {
          return { ...item, configurado: value.configurado };
        }
        return item;
      });
    });
    setTieneModificacionesPendientes(true);
  };

  const onPrestadorStandVirtualChange = (value) => {
    props.actualizarPrestadorStandVirtual({
      tipoPss: formData.tipoPss,
      codigoPss: formData.codigoPss,
      standVirtualHabilitado: value
    });
  };

  const onFiltrarPorCobertura = (clean = false) => {
    setCurrentPage(1);
    setCoberturasOriginales([]);
    setCoberturas([]);
    setCambiosPendientes(new Map());

    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.obtenerCoberturasPss({
      numeroSesion: numeroSesionReutilizable,
      compania: empresa?.CODIGO,
      datosPSS: {
        ...formData,
        tipoProcedimiento: procedimientoSeleccionado.codigoTipoCobertura,
        numeroPagina: 1,
        tamanoPagina: itemsPerPage,
        cobertura: clean ? "" : filtroCobertura
      }
    });
  };

  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.datosPssData) &&
      !isObjectEmpty(props?.datosPssData) &&
      processing
    ) {
      setPrestador(props?.datosPssData?.prestador);
      setProcedimientos(props?.datosPssData?.procedimientos);
      setProcessing(false);
      setMostrarDetalle(true);
      setProcedimientoSeleccionado(null);
      setTieneModificacionesPendientes(false);
      setCoberturas([]);
      return;
    }
  }, [props.datosPssData]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.datosPssError) && processing) {
      setProcessing(false);
      setMostrarDetalle(false);
      setProcedimientos([]);
      setProcedimientoSeleccionado(null);
      mostrarErrorGenerico(
        props?.datosPssError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.datosPssError]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.coberturasPssData) && processing) {
      setProcessing(false);

      const data = props?.coberturasPssData?.coberturas || [];

      if (data.length === 0) {
        setAlertConfig({
          type: "info",
          title: "¡Hola!",
          message:
            "No se encontraron coberturas para el tipo de procedimiento seleccionado.",
          onConfirm: () => {
            setShowAlert(false);
          }
        });
        setShowAlert(true);
      }

      setCoberturasOriginales(JSON.parse(JSON.stringify(data)));
      setCoberturas(data);

      const totalRegs = props?.coberturasPssData?.totalRegistros || 0;
      setTotalRegistros(totalRegs);
    }
  }, [props.coberturasPssData]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.coberturasPssError) && processing) {
      mostrarErrorGenerico(
        props?.coberturasPssError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.coberturasPssError]);

  useUpdateEffect(() => {
    if (isObjectEmpty(props?.guardarcoberturasPssData)) return;

    setCambiosPendientes(new Map());

    setAlertConfig({
      type: "info",
      title: "Configuración Guardada Correctamente",
      message: `Se configuraron ${props.guardarcoberturasPssData.coberturasAgregadas} coberturas para el tipo procedimiento ${procedimientoSeleccionado.codigoTipoCobertura} - ${procedimientoSeleccionado.descripcionTipoCobertura}`,
      onConfirm: () => {
        setShowAlert(false);
        setProcessing(true);
        setTieneModificacionesPendientes(false);
        setTimeout(() => {
          const { numeroSesionReutilizable } = props?.authUserData;
          setFiltroCobertura("");
          props.obtenerCoberturasPss({
            numeroSesion: numeroSesionReutilizable,
            compania: empresa?.CODIGO,
            datosPSS: {
              ...formData,
              tipoProcedimiento: procedimientoSeleccionado.codigoTipoCobertura,
              numeroPagina: currentPage,
              tamanoPagina: itemsPerPage
            }
          });
        }, 500);
      }
    });

    setShowAlert(true);
  }, [props.guardarcoberturasPssData]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.guardarcoberturasPssError) && processing) {
      mostrarErrorGenerico(
        props?.guardarcoberturasPssError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.guardarcoberturasPssError]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.actualizarPrestadorStandVirtualData)) {
      setPrestador((prevState) => {
        return {
          ...prevState,
          standVirtualHabilitado:
            props?.actualizarPrestadorStandVirtualData?.prestador
              ?.standVirtualHabilitado ?? prevState.standVirtualHabilitado
        };
      });
      setAlertConfig({
        type: "info",
        title: "Configuración Actualizada",
        message: `La configuración del Stand Virtual del prestador se actualizó correctamente.`,
        onConfirm: () => {
          setShowAlert(false);
        }
      });
      setShowAlert(true);
    }
  }, [props.actualizarPrestadorStandVirtualData]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.actualizarPrestadorStandVirtualError)) {
      mostrarErrorGenerico(
        props?.actualizarPrestadorStandVirtualError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.actualizarPrestadorStandVirtualError]);

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <>
      <Section>
        <TittleLine title={"Configuración Stand Virtual"} weight={"bold"} />
      </Section>

      <ConfiguracionStandVirtualBusquedaForm
        {...formData}
        onStateChange={onStateChange}
        onSearch={buscarProcedimientos}
        isLoading={props.datosPssLoading}
        handleKeyPress={handleKeyPress}
      />

      <CheckRender allowed={mostrarDetalle}>
        <ConfiguracionStandVirtualBusquedaDetalle
          prestador={prestador}
          coberturas={coberturas}
          procedimientos={procedimientos}
          procedimientoSeleccionado={procedimientoSeleccionado}
          filtroCobertura={filtroCobertura}
          paginacion={{
            numeroPagina: currentPage,
            tamanoPagina: itemsPerPage,
            totalRegistros: totalRegistros
          }}
          tieneModificacionesPendientes={tieneModificacionesPendientes}
          onChangeProcedimientoSeleccionado={onChangeProcedimientoSeleccionado}
          onChangeCoberturaSelectionChanged={onChangeCoberturaEstatus}
          onChangeSelecionarTodosCoberturas={onChangeSelecionarTodosCoberturas}
          onGuardarCoberturas={guardarCoberturas}
          onPageChange={handlePageChange}
          onPrestadorStandVirtualChange={onPrestadorStandVirtualChange}
          onFiltroCoberturaChange={setFiltroCobertura}
          onFiltrarPorCobertura={onFiltrarPorCobertura}
        />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  datosPssData: state.cobertura.obtenerDatosPssData,
  datosPssLoading: state.cobertura.obtenerDatosPssLoading,
  datosPssError: state.cobertura.obtenerDatosPssError,
  coberturasPssData: state.cobertura.obtenerCoberturaContratadaPssData,
  coberturasPssLoading: state.cobertura.obtenerCoberturaContratadaPssLoading,
  coberturasPssError: state.cobertura.obtenerCoberturaContratadaPssError,
  guardarcoberturasPssData: state.cobertura.guardarCoberturaContratadaPssData,
  guardarcoberturasPssLoading:
    state.cobertura.guardarCoberturaContratadaPssLoading,
  guardarcoberturasPssError: state.cobertura.guardarCoberturaContratadaPssError,
  actualizarPrestadorStandVirtualData:
    state.prestador.actualizarPrestadorStandVirtualData,
  actualizarPrestadorStandVirtualLoading:
    state.prestador.actualizarPrestadorStandVirtualLoading,
  actualizarPrestadorStandVirtualError:
    state.prestador.actualizarPrestadorStandVirtualError
});

const mapDispatchToProps = {
  obtenerDatosPss: ConfiguracionStandVirtualActions.obtenerDatosPss,
  obtenerCoberturasPss:
    ConfiguracionStandVirtualActions.obtenerCoberturaContratadaPss,
  guardarCoberturasPss:
    ConfiguracionStandVirtualActions.guardarCoberturaContratadaPss,
  actualizarPrestadorStandVirtual:
    PrestadorStandVirtualActions.actualizarPrestadorStandVirtual
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ConfiguracionStandVirtualScreen);
